import { addZero } from '../../../lib/commonService';

export function getS3Folder () {
  const folder = 'images/users';
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${folder}/${year}/${addZero(month)}${addZero(day)}/`;
}

export function getFileHash () {
  let now = Date.now();
  const uuid = 'xxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (now + Math.random() * 16) % 16 | 0;
    now = Math.floor(now / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return (
    uuid +
    Math.random()
      .toString(16)
      .substring(2)
  );
}

// 判断当前地址是不是南非
export const isSouthAfricaCountry = (currentAddress: any, countries: any[]) => {
  if (currentAddress && currentAddress.countries && countries && Array.isArray(countries)) {
    const currentCountry = countries.find((item: any) => item && item.countries_id === currentAddress.countries.countries_id)
    if (currentCountry && currentCountry.countries_iso_code_3 === 'ZAF') {
      return true
    }
  }
  return false
}
